export default __webpack_public_path__ + "static/media/spice-red.4fd0bad1.svg";